/********************************************************************
 * Project: WDCK（2021）
 * Class: DateFormatDirective
 * ----------------------------------------
 * <summary>
 * Check format of date
 * </summary>
 * <history>
 *      NghiaTQ     2021/09/09      Create
 *      NghiaNX     2021/09/28      Updating common
 * </history>
 ********************************************************************/
import { Directive, ElementRef, EventEmitter, HostListener, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import * as moment from 'moment';
import { Utility } from '../utility/utility';

@Directive({
    selector: '[dateFormat]',
    // tslint:disable-next-line: no-host-metadata-property
    host: {
        '(focusout)': 'onFocusOut()',
    }
})
export class DateFormatDirective implements OnChanges {
    // Allow decimal numbers and negative values
    private pattern = 'YYYY/MM/DD';
    private rowValue = '';
    @Input() dateFormat: any;
    @Output() eventBlurOutput = new EventEmitter();
    regexDate = /[^0-9*/]/g;
    private dateForZero = '1990/01/01';
    private flag = false;
    constructor(private el: ElementRef, private util: Utility) {
    }
    ngOnChanges(changes: SimpleChanges): void {
        if (changes.dateFormat && !this.util.isNullOrBlank(changes.dateFormat.currentValue)
            && this.util.compareTwoDate(changes.dateFormat.previousValue, changes.dateFormat.currentValue)) {
            if (!this.flag) {
                console.log('onchange');
                this.eventBlurOutput.emit(changes.dateFormat.currentValue);
            }
        }
    }

    @HostListener('paste', ['$event']) blockPaste(e: KeyboardEvent) {
        e.preventDefault();
    }
    @HostListener('input', ['$event']) onInputChange(event) {
        this.flag = true;
        const initVal = this.el.nativeElement.value;
        this.el.nativeElement.value = this.DateToString();
        if (initVal !== this.el.nativeElement.value) {
            event.stopPropagation();
        }
        this.rowValue = this.el.nativeElement.value;
    }

    DateToString(): string {
        return this.el.nativeElement.value.replace(this.regexDate, '');
    }
    onFocusOut(): void {
        if (this.flag === true) {
            this.flag = false;
            // get current year , month
            const curDate = new Date();
            const curY = (curDate.getFullYear()).toString();
            const curM = curDate.getMonth() > 8 ? (curDate.getMonth() + 1).toString() : '0' + (curDate.getMonth() + 1).toString();
            const dateVal = this.CheckInputToSetDate(curY, curM);
            let date: Date = null;
            if (!this.util.isNullOrBlank(dateVal)) {
                if (this.CheckDateValid(dateVal, this.pattern)) {
                    date = moment(dateVal, this.pattern, true).toDate();
                }
                if (date == null) {
                    const newDate = curY + '/' + curM + '/01';
                    date = moment(newDate, this.pattern, true).toDate();
                }
            }
            console.log('focusout');
            this.eventBlurOutput.emit(date);
        }
    }
    CheckInputToSetDate(curY: string, curM: string) {
        let retValue = this.rowValue;
        if (this.util.isNullOrBlank(retValue)) {
            return retValue;
        }
        const isAllZero = this.checkInpAllZero(retValue);
        if (isAllZero) {
            return this.dateForZero;
        }
        if (!this.util.isNullOrBlank(retValue)) {
            const replaceVal = retValue.replace(/[\/]/g, '');
            switch (retValue.length) {
                case 1:
                    retValue = curY + '/' + curM + '/0' + this.rowValue;
                    break;
                case 2:
                    retValue = curY + '/' + curM + '/' + this.rowValue;
                    break;
                case 8:
                case 10:
                    if (replaceVal.length === 8) {
                        retValue = replaceVal.substring(0, 4) + '/' + replaceVal.substring(4, 6) + '/' + replaceVal.substring(6);
                    }
                    break;
            }
        }
        return retValue;
    }
    CheckDateValid(pDate: string, pFormat: string) {
        return moment(pDate, pFormat, true).isValid();
    }
    checkInpAllZero(value) {
        const checkDt = value.replace(/[\/]/g, '');
        return checkDt.split('').every(char => char === '0');
    }
}
